<!-- HEADER BANNER -->
<div class="d-flex flex-column flex-md-row align-items-center justify-content-between mt-4 header-banner">
  <div class="float-md-end mx-5 mx-md-0">
    <picture>
      <source srcset="https://{{ environment.imagesServer }}/web/ranking/boy-with-prize.webp" type="image/webp" />
      <img class="img-fluid" src="https://{{ environment.imagesServer }}/web/ranking/boy-with-prize.png" alt="Boy with cup" width="493" height="459" />
    </picture>
  </div>
  <div>
    <picture>
      <source srcset="https://{{ environment.imagesServer }}/web/ranking/code-race.webp" type="image/webp" />
      <img class="img-fluid" src="https://{{ environment.imagesServer }}/web/ranking/code-race.png" alt="Code Race button" width="499" height="244" />
    </picture>
  </div>
  <div class="d-block float-md-start mx-5 mx-md-0">
    <picture>
      <source srcset="https://{{ environment.imagesServer }}/web/ranking/girl-with-prize.webp" type="image/webp" />
      <img class="img-fluid" src="https://{{ environment.imagesServer }}/web/ranking/girl-with-prize.png" alt="Girl with cup" width="491" height="475" />
    </picture>
  </div>
</div>

<div class="fs-3 my-3 text-center w-100" *ngIf="isReading && !errorReading"><fa-icon [icon]="faSpinner" animation="spin"></fa-icon> Loading</div>
<div *ngIf="!isReading && !errorReading">

  <!-- HEADER -->
  <div class="d-flex flex-column flex-sm-row align-items-center justify-content-between">
    <h1 class="mb-3 mt-3 theme-text-title-color">Rankings</h1>
    <div class="fs-4 mb-4 mb-sm-0">
      <input class="border border-info rounded" (blur)="onChangeFullText()" (keyup.enter)="onChangeFullText()" [(ngModel)]="fullText" placeholder="Name search" type="text" />
    </div>
  </div>

  <!-- DESCRIPTION -->
  <div class="card mb-3 p-3 theme-tile-bg-color">
    <h5 class="theme-text-title-color">Understanding the Rankings</h5>
    The Code Race&trade; ranking lists all young coders who have participated in Code Race contests, with players who have higher ratings listed first. A rating is a number that measures how well you code, based on your performance in contests.
    <div class="mt-2" *ngIf="!isDescriptionExpanded"><span class="cwk-link theme-link-color" (click)="expandDescription()">Read More</span></div>
    <div class="mt-3" *ngIf="isDescriptionExpanded">
      Think of your Code Race&trade; rating like a video game level, the higher your level, the better you are at coding! After each contest, you get a placement (like 1st, 2nd, or 3rd), and your rating goes up or down depending on how well you did. If you beat coders with higher ratings, your rating increases a lot. If you lose to lower rating coders, your rating drops a little. The goal is to keep improving your skills and climbing the ranks!
    </div>
  </div>

  <!-- RANKINGS -->
  <!--div class="card mb-3 p-3 theme-tile-bg-color" *sharedPrerenderOnly>
    <div class="my-3 text-center w-100"><fa-icon [icon]="faSpinner" animation="spin"></fa-icon> Initializing</div>
  </div-->
  <div class="card mb-3 p-3 theme-tile-bg-color" *sharedNoPrerender>
    <div class="d-flex header-row align-items-center sticky-top">
      <div class="item pe-3 position text-end" (click)="sort('Position')">
        <span class="d-inline d-sm-none"><fa-icon [icon]="faRankingStar"></fa-icon></span>
        <span class="d-none d-sm-inline">Rank</span>
        <ng-container *ngTemplateOutlet="sortIcons; context: { column: 'Position', sortColumn: sortColumn, sortOrderDesc: sortOrderDesc }"></ng-container>
      </div>
      <div class="item participant" (click)="sort('FirstName')">Participant<ng-container *ngTemplateOutlet="sortIcons; context: { column: 'FirstName', sortColumn: sortColumn, sortOrderDesc: sortOrderDesc }"></ng-container></div>
      <div class="item d-none d-md-block user-name" (click)="sort('Account')">Username<ng-container *ngTemplateOutlet="sortIcons; context: { column: 'Account', sortColumn: sortColumn, sortOrderDesc: sortOrderDesc }"></ng-container></div>
      <div class="item d-none d-md-block age pe-3 text-end" (click)="sort('Age')">Age<ng-container *ngTemplateOutlet="sortIcons; context: { column: 'Age', sortColumn: sortColumn, sortOrderDesc: sortOrderDesc }"></ng-container></div>
      <div class="item d-none d-lg-block location" (click)="sort('Location')">Location<ng-container *ngTemplateOutlet="sortIcons; context: { column: 'Location', sortColumn: sortColumn, sortOrderDesc: sortOrderDesc }"></ng-container></div>
      <div class="item contests ms-auto text-center" (click)="sort('CompetitionsCount')">
        <span class="d-inline d-sm-none"><fa-icon [icon]="faHashtag"></fa-icon></span>
        <span class="d-none d-sm-inline">Contests</span>
        <span class="d-none d-lg-inline"> Completed</span>
        <ng-container *ngTemplateOutlet="sortIcons; context: { column: 'CompetitionsCount', sortColumn: sortColumn, sortOrderDesc: sortOrderDesc }"></ng-container>
      </div>
      <div class="item ranking text-end" (click)="sort('Ranking')">
        <span class="d-inline d-sm-none"><fa-icon [icon]="faEquals"></fa-icon></span>
        <span class="d-none d-sm-inline">Rating</span>
        <ng-container *ngTemplateOutlet="sortIcons; context: { column: 'Ranking', sortColumn: sortColumn, sortOrderDesc: sortOrderDesc }"></ng-container></div>
    </div>
    <div class="d-flex ranking-row align-items-center cwk-pointer" (click)="goProfile(ranking.StudentId)" *ngFor="let ranking of rankings2Show; let index = index">
      <div class="item pe-3 position text-end">{{ ranking.Position }}</div>
      <div class="item participant">
        <img class="icon-avatar bg-body img-fluid rounded-circle" src="https://d3t4xfu733v2tb.cloudfront.net/web/account/avatars/{{ ranking.AvatarPath || 'empty.png' }}" alt="Participant avatar" loading="lazy" width="200" height="200" />
        <span class="ms-1">{{ ranking.FirstName }} {{ ranking.LastName[0] }}.</span>
        <span class="d-inline d-md-none">({{ ranking.Account }}, {{ ranking.Age ? ranking.Age + ' y.o.' : '' }})</span>
      </div>
      <div class="item d-none d-md-block user-name">{{ ranking.Account }}</div>
      <div class="item d-none d-md-block age pe-3 text-end">{{ ranking.Age }}</div>
      <div class="item d-none d-lg-block location">{{ ranking.Location }}</div>
      <div class="item contests ms-auto text-center">{{ ranking.CompetitionsCount }}</div>
      <div class="item ranking text-end">{{ ranking.Ranking }}</div>
    </div>
    <div class="mt-3 text-center" *ngIf="isRankingsMore"><button class="btn btn-warning" (click)="showMoreRankings()">Show More</button></div>
  </div>
  <!--div class="fs-4 mt-3 p-4 rounded theme-tile-bg-color" *ngIf="!rankings2Show.length">
    Initial rankings for students who participated in our spring preview competitions have been calculated. We are in the process of finalizing their transition to this new platform, Code Race&trade;. Updated rankings will be posted no later than December 11, 2024.
  </div-->

  <!-- TEMPLATE FOR SORT ICONS -->
  <ng-template #sortIcons let-column="column" let-sortColumn="sortColumn" let-sortOrderDesc="sortOrderDesc">
    <fa-stack class="ms-1 stack-icons">
      <fa-icon [icon]="faSortUp" [ngClass]="{ 'hidden': column !== sortColumn || sortOrderDesc }" stackItemSize="1x"></fa-icon>
      <fa-icon [icon]="faSortDown" [ngClass]="{ 'hidden': column !== sortColumn || !sortOrderDesc }" stackItemSize="1x"></fa-icon>
    </fa-stack>
  </ng-template>
</div>
